/* PALMZ Theme · vyce.js · Vanilla, kein Framework */
(function () {
  'use strict';

  var doc = document.documentElement;
  var reduceMq = matchMedia('(prefers-reduced-motion: reduce)');

  function setAnimClass() { doc.classList.toggle('anim', !reduceMq.matches); }
  setAnimClass();

  /* ---------- Boot ---------- */
  var boot = document.getElementById('boot');
  function killBoot(instant) {
    if (!boot) return;
    if (instant) { boot.remove(); boot = null; return; }
    boot.classList.add('done');
    setTimeout(function () { if (boot) { boot.remove(); boot = null; } }, 650);
    try { sessionStorage.setItem('vyce-booted', '1'); } catch (e) {}
  }
  var seenBoot = false;
  try { seenBoot = sessionStorage.getItem('vyce-booted') === '1'; } catch (e) {}
  if (reduceMq.matches || seenBoot || window.Shopify && window.Shopify.designMode) killBoot(true);
  else {
    var bootDone = false;
    var finish = function () { if (!bootDone) { bootDone = true; killBoot(false); } };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { setTimeout(finish, 600); });
    setTimeout(finish, 1400);
  }

  /* ---------- Toast ---------- */
  var toastEl = document.getElementById('toast');
  var toastTimer = null;
  function toast(title, sub) {
    if (!toastEl) return;
    toastEl.innerHTML = '<p class="t-title"></p><p class="t-sub"></p>';
    toastEl.firstChild.textContent = title;
    toastEl.lastChild.textContent = sub || '';
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 3400);
  }

  /* ---------- Merken-Buttons (Karten kommen aus Liquid) ---------- */
  var favs = [];
  try { favs = JSON.parse(localStorage.getItem('vyce-favs') || '[]'); } catch (e) {}
  document.querySelectorAll('.fav').forEach(function (fav) {
    var id = fav.dataset.id || '';
    var name = fav.dataset.name || 'Produkt';
    function paintFav(on) {
      fav.textContent = on ? '⭐' : '☆';
      fav.classList.toggle('on', on);
      fav.setAttribute('aria-pressed', on ? 'true' : 'false');
      fav.setAttribute('aria-label', (on ? 'Nicht mehr merken: ' : 'Merken: ') + name);
    }
    paintFav(favs.indexOf(id) !== -1);
    fav.addEventListener('click', function () {
      var i = favs.indexOf(id);
      var on = i === -1;
      if (on) favs.push(id); else favs.splice(i, 1);
      try { localStorage.setItem('vyce-favs', JSON.stringify(favs)); } catch (e) {}
      paintFav(on);
      if (on) toast('Gemerkt ⭐', name + ' steht auf deiner Liste für Drop 01.');
    });
  });

  /* ---------- Split-Text ---------- */
  function rng(seed) {
    var s = seed >>> 0;
    return function () { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; };
  }
  document.querySelectorAll('.split').forEach(function (el, elIdx) {
    var mode = el.dataset.entrance || 'scatter';
    var spread = parseFloat(el.dataset.spread || '0.55');
    var r = rng(1337 + elIdx * 101);
    var words = el.textContent.split(/\s+/).filter(Boolean);
    el.textContent = '';
    var charTotal = 0;
    words.forEach(function (w) { charTotal += Array.from(w).length; });
    var charIdx = 0;
    words.forEach(function (w, wi) {
      var ws = document.createElement('span');
      ws.className = 'w';
      if (mode === 'punch' || mode === 'drift' || mode === 'rise') {
        ws.style.setProperty('--th', (wi / Math.max(1, words.length) * 0.5 + r() * 0.05).toFixed(3));
      }
      if (mode === 'scatter' || mode === 'gridsnap') {
        Array.from(w).forEach(function (ch) {
          var cs = document.createElement('span');
          cs.className = 'c';
          cs.textContent = ch;
          if (mode === 'scatter') {
            cs.style.setProperty('--th', (r() * spread).toFixed(3));
            cs.style.setProperty('--jx', ((r() * 2 - 1) * 70).toFixed(1) + 'px');
            cs.style.setProperty('--jy', ((r() * 2 - 1) * 44).toFixed(1) + 'px');
            cs.style.setProperty('--jr', ((r() * 2 - 1) * 24).toFixed(1) + 'deg');
          } else {
            cs.style.setProperty('--th', (charIdx / Math.max(1, charTotal) * spread + r() * 0.06).toFixed(3));
            cs.style.setProperty('--jx', ((charIdx % 2 ? -1 : 1) * (30 + r() * 26)).toFixed(1) + 'px');
          }
          charIdx++;
          ws.appendChild(cs);
        });
      } else {
        ws.textContent = w;
      }
      el.appendChild(ws);
      if (wi < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
  });

  /* ---------- Hero-Scrub-Engine (nur wenn die Hero-Sektion existiert) ---------- */
  var hero = document.getElementById('hero');
  var applyHeroMode = function () {};

  function smoothstep(p, e0, e1) {
    var t = Math.min(1, Math.max(0, (p - e0) / (e1 - e0)));
    return t * t * (3 - 2 * t);
  }
  var clamp01 = function (v) { return Math.min(1, Math.max(0, v)); };

  if (hero) (function () {
    var stage = hero.querySelector('.stage');
    var cue = hero.querySelector('.cue');
    var bandEls = Array.prototype.slice.call(hero.querySelectorAll('.band'));
    var bands = bandEls.map(function (el, i) {
      var a = parseFloat(el.dataset.a), b = parseFloat(el.dataset.b);
      return { el: el, a: a, b: b, f: Math.min(0.02, (b - a) / 3),
        ramp: parseFloat(el.dataset.ramp || '') || Math.min(0.025, (b - a) * 0.35),
        first: i === 0, last: i === bandEls.length - 1, op: -1, k: -1, vis: null };
    });

    var heroH = 0, vh = 0;
    function measure() { heroH = hero.offsetHeight; vh = stage.offsetHeight || innerHeight; }
    measure();
    addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });

    function heroProgress() {
      var range = heroH - vh;
      var top = hero.getBoundingClientRect().top + scrollY;
      return range > 0 ? clamp01((scrollY - top) / range) : 1;
    }

    var target = 0, shown = 0, rafId = null, lastTick = 0;
    var lastP = -1, neonOn = null, cueGone = null;
    var loadK = 0, loadK_t0 = 0;

    function updateCaptions(p) {
      if (Math.abs(p - lastP) > 0.002) {
        lastP = p;
        stage.style.setProperty('--p', p.toFixed(4));
      }
      var wantNeon = p >= 0.60 ? true : (p < 0.56 ? false : neonOn);
      if (wantNeon !== neonOn) { neonOn = wantNeon; stage.classList.toggle('neon-on', !!neonOn); }
      var wantCueGone = p > 0.02;
      if (cue && wantCueGone !== cueGone) { cueGone = wantCueGone; cue.classList.toggle('gone', wantCueGone); }

      bands.forEach(function (bd) {
        var inO = bd.first ? 1 : smoothstep(p, bd.a, bd.a + bd.f);
        var outO = bd.last ? 1 : 1 - smoothstep(p, bd.b - bd.f, bd.b);
        var op = inO * outO;
        var k = clamp01((p - bd.a) / bd.ramp);
        if (bd.first && loadK < 1) k = Math.max(k, loadK);
        if (Math.abs(op - bd.op) > 0.01 || (op > 0) !== (bd.op > 0)) {
          bd.op = op;
          bd.el.style.opacity = op.toFixed(3);
        }
        var vis = op > 0.02;
        if (vis !== bd.vis) { bd.vis = vis; bd.el.style.visibility = vis ? 'visible' : 'hidden'; }
        if (Math.abs(k - bd.k) > 0.008 || (k === 0) !== (bd.k === 0) || (k === 1) !== (bd.k === 1)) {
          bd.k = k;
          bd.el.style.setProperty('--k', k.toFixed(3));
        }
      });
    }

    function onScroll() {}

    var heroOnScreen = true;
    var playing = false, rafId2 = null, pNow = 0, lastT = 0, holdUntil = 0, fading = false;
    var T = ((parseFloat(stage.dataset.autoplay) || 32) * 1000);
    var HOLD = 6000, FADE = 900;

    new IntersectionObserver(function (entries) {
      heroOnScreen = entries[0].isIntersecting;
      if (heroOnScreen && playing && rafId2 === null) { lastT = 0; rafId2 = requestAnimationFrame(autoTick); }
    }).observe(hero);

    function autoTick(now) {
      if (!playing || !heroOnScreen) { rafId2 = null; lastT = 0; return; }
      var dt = Math.min(100, now - (lastT || now));
      lastT = now;
      if (!fading) {
        if (holdUntil) {
          if (now >= holdUntil) {
            holdUntil = 0; fading = true;
            stage.classList.add('loopfade');
            setTimeout(function () {
              pNow = 0;
              bands.forEach(function (b) { b.op = -1; b.k = -1; b.vis = null; });
              lastP = -1; neonOn = null;
              updateCaptions(0);
              requestAnimationFrame(function () { requestAnimationFrame(function () {
                stage.classList.remove('loopfade'); fading = false;
              }); });
            }, FADE);
          }
        } else {
          pNow = Math.min(1, pNow + dt / T);
          updateCaptions(pNow);
          if (pNow >= 1) holdUntil = now + HOLD;
        }
      }
      rafId2 = requestAnimationFrame(autoTick);
    }

    var STATIC_GATES = [
      '(orientation: landscape) and (pointer: coarse) and (max-height: 560px)',
      '(prefers-reduced-motion: reduce)'
    ];
    function stopAuto() {
      playing = false;
      if (rafId2 !== null) { cancelAnimationFrame(rafId2); rafId2 = null; }
      doc.classList.remove('autoplay');
      stage.classList.remove('loopfade');
      stage.style.setProperty('--p', '1');
      stage.classList.add('neon-on');
    }
    function startAuto() {
      if (playing) return;
      playing = true;
      doc.classList.add('autoplay');
      stage.classList.remove('neon-on');
      pNow = 0; holdUntil = 0; fading = false;
      bands.forEach(function (b) { b.op = -1; b.k = -1; b.vis = null; });
      lastP = -1; neonOn = null; loadK = 1;
      updateCaptions(0);
      lastT = 0;
      if (rafId2 === null) rafId2 = requestAnimationFrame(autoTick);
    }
    applyHeroMode = function () {
      if (STATIC_GATES.some(function (q) { return matchMedia(q).matches; })) stopAuto();
      else startAuto();
    };

    window.__vyce = {
      seek: function (p) {
        playing = false;
        if (rafId2 !== null) { cancelAnimationFrame(rafId2); rafId2 = null; }
        doc.classList.add('autoplay');
        pNow = p; loadK = 1;
        updateCaptions(p);
      },
      state: function () { return { p: pNow, autoplay: playing }; },
      play: function () { startAuto(); }
    };

    var MQLS = STATIC_GATES.map(function (q) { return matchMedia(q); });
    MQLS.forEach(function (m) {
      var fn = function () { applyHeroMode(); };
      if (m.addEventListener) m.addEventListener('change', fn); else m.addListener(fn);
    });
    applyHeroMode();
  })();

  /* ---------- Nav ---------- */
  var nav = document.querySelector('.nav');
  if (nav) {
    var navOn = null;
    addEventListener('scroll', function () {
      var want = scrollY > 40;
      if (want !== navOn) { navOn = want; nav.classList.toggle('scrolled', want); }
    }, { passive: true });
  }

  /* ---------- Reveals ---------- */
  var revTargets = [];
  document.querySelectorAll('.sec-head, .loadout-cta, .faq-list, .cta-panel, .respect > *:not(.reward):not(.hold-btn)').forEach(function (el) {
    el.classList.add('rev'); revTargets.push(el);
  });
  document.querySelectorAll('.cards, .look-row, .divider').forEach(function (el) { revTargets.push(el); });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('in');
      io.unobserve(en.target);
      if (en.target.classList.contains('cards')) {
        setTimeout(function () { en.target.classList.add('settled'); }, 1600);
      }
    });
  }, { threshold: 0.02 });
  revTargets.forEach(function (el) { io.observe(el); });

  if (!window.__vyce) window.__vyce = { seek: function () {}, state: function () { return {}; } };
  window.__vyce.revealAll = function () { revTargets.forEach(function (el) { el.classList.add('in', 'settled'); }); };

  /* ---------- Ticker: nur sichtbar animieren ---------- */
  var ticker = document.querySelector('.ticker');
  if (ticker) {
    new IntersectionObserver(function (en) {
      ticker.classList.toggle('anim-on', en[0].isIntersecting);
    }).observe(ticker);
  }

  /* ---------- Tab versteckt: alles pausieren ---------- */
  document.addEventListener('visibilitychange', function () {
    document.body.classList.toggle('paused', document.hidden);
  });

  /* ---------- Respect-Hold ---------- */
  var holdBtn = document.getElementById('holdBtn');
  var reward = document.getElementById('reward');
  var stars = Array.prototype.slice.call(document.querySelectorAll('.wstar'));
  var holdP = 0, holding = false, holdRaf = null, holdLast = 0, respectDone = false;
  try { respectDone = localStorage.getItem('vyce-respect') === '1'; } catch (e) {}

  if (holdBtn && reward) (function () {
    function paintHold() {
      var lit = Math.floor(holdP * 5 + 1e-6);
      stars.forEach(function (s, i) { s.classList.toggle('lit', i < lit); });
      holdBtn.style.setProperty('--hold', holdP.toFixed(2));
    }
    function finishRespect(silent) {
      respectDone = true;
      holdP = 1; paintHold();
      holdBtn.classList.add('finished');
      holdBtn.classList.remove('holding');
      reward.classList.add('show');
      try { localStorage.setItem('vyce-respect', '1'); } catch (e) {}
      if (!silent) toast('MISSION PASSED ✔', 'Respect +. Dein Code ist freigeschaltet.');
    }
    if (respectDone) finishRespect(true);

    function holdTick(now) {
      var dt = Math.min(80, now - (holdLast || now));
      holdLast = now;
      holdP += (holding ? dt / 1800 : -dt / 900);
      holdP = clamp01(holdP);
      paintHold();
      if (holdP >= 1) { finishRespect(false); holdRaf = null; holdLast = 0; return; }
      if (!holding && holdP <= 0) { holdRaf = null; holdLast = 0; return; }
      holdRaf = requestAnimationFrame(holdTick);
    }
    function holdStart(e) {
      if (respectDone) return;
      if (e.type === 'pointerdown') e.preventDefault();
      holding = true;
      holdBtn.classList.add('holding');
      if (holdRaf === null) holdRaf = requestAnimationFrame(holdTick);
    }
    function holdEnd() {
      holding = false;
      holdBtn.classList.remove('holding');
      if (holdRaf === null && holdP > 0) holdRaf = requestAnimationFrame(holdTick);
    }
    holdBtn.addEventListener('pointerdown', holdStart);
    addEventListener('pointerup', holdEnd);
    addEventListener('pointercancel', holdEnd);
    holdBtn.addEventListener('keydown', function (e) {
      if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) { e.preventDefault(); holdStart(e); }
    });
    holdBtn.addEventListener('keyup', function (e) {
      if (e.key === ' ' || e.key === 'Enter') holdEnd();
    });
    holdBtn.addEventListener('blur', holdEnd);
  })();

  var codeChip = document.getElementById('codeChip');
  if (codeChip) {
    var CODE = codeChip.dataset.code || 'RESPECT15';
    var copyCode = function () {
      var done = function () { toast('Kopiert ✔', CODE + ' ist in deiner Zwischenablage.'); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(CODE).then(done, done);
      else done();
    };
    codeChip.addEventListener('click', copyCode);
    codeChip.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); copyCode(); }
    });
  }

  /* ---------- Formular (mailto, ehrlich) ---------- */
  var form = document.getElementById('dropForm');
  if (form) {
    var formDone = document.getElementById('formDone');
    var MAILTO = form.dataset.email || 'info@dealzaza.com';
    var SUBJECT = form.dataset.subject || 'Drop-Liste PALMZ';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = (document.getElementById('f-name') || { value: '' }).value.trim();
      var mail = document.getElementById('f-mail');
      var val = mail.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val)) {
        mail.classList.add('err');
        mail.focus();
        toast('Moment 🕹️', 'Die E-Mail-Adresse sieht noch nicht richtig aus.');
        return;
      }
      mail.classList.remove('err');
      var body = 'Hi PALMZ Team,\n\nsetzt mich auf die Drop-01-Liste.\n\nName: ' + (name || '-') + '\nE-Mail: ' + val + '\n\nDanke!';
      location.href = 'mailto:' + MAILTO + '?subject=' + encodeURIComponent(SUBJECT) + '&body=' + encodeURIComponent(body);
      form.hidden = true;
      if (formDone) formDone.hidden = false;
      toast('MISSION PASSED ✔', 'Nur noch absenden, dann bist du drauf.');
    });
    var mailEl = document.getElementById('f-mail');
    if (mailEl) mailEl.addEventListener('input', function () { this.classList.remove('err'); });
  }

  /* ---------- Dialoge ---------- */
  document.querySelectorAll('[data-dialog]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var d = document.getElementById(btn.dataset.dialog);
      if (d && d.showModal) d.showModal();
    });
  });
  document.querySelectorAll('dialog').forEach(function (d) {
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    d.querySelectorAll('[data-close]').forEach(function (c) {
      c.addEventListener('click', function () { d.close(); });
    });
  });

  /* ---------- Cursor-Glow ---------- */
  var fineMq = matchMedia('(pointer: fine)');
  var cursor = document.getElementById('cursor');
  if (cursor) {
    var cx = -100, cy = -100, tx = -100, ty = -100, curRaf = null;
    var cursorTick = function () {
      cx += (tx - cx) * 0.22;
      cy += (ty - cy) * 0.22;
      cursor.style.transform = 'translate(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px)';
      if (Math.abs(tx - cx) + Math.abs(ty - cy) > 0.4) curRaf = requestAnimationFrame(cursorTick);
      else curRaf = null;
    };
    var setCursorMode = function () {
      doc.classList.toggle('fine-cursor', fineMq.matches && !reduceMq.matches);
    };
    setCursorMode();
    if (fineMq.addEventListener) fineMq.addEventListener('change', setCursorMode);
    addEventListener('pointermove', function (e) {
      if (!doc.classList.contains('fine-cursor')) return;
      tx = e.clientX; ty = e.clientY;
      if (curRaf === null) curRaf = requestAnimationFrame(cursorTick);
    }, { passive: true });
  }

  /* ---------- Konami ---------- */
  var seq = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
  var pos = 0;
  addEventListener('keydown', function (e) {
    var k = e.key.length === 1 ? e.key.toLowerCase() : e.key;
    pos = (k === seq[pos]) ? pos + 1 : (k === seq[0] ? 1 : 0);
    if (pos === seq.length) {
      pos = 0;
      var on = doc.classList.toggle('cheat');
      toast(on ? 'CHEAT AKTIVIERT 👾' : 'Cheat aus 🕹️', on ? 'RGB-Mode an. Du kennst die Codes.' : 'Zurück im Vice-Mode.');
    }
  });

  /* ---------- Reduced Motion live, in beide Richtungen ---------- */
  function pinToFinalStates() {
    revTargets.forEach(function (el) { el.classList.add('in', 'settled'); });
    if (reward && !respectDone) { stars.forEach(function (s) { s.classList.add('lit'); }); reward.classList.add('show'); }
    if (holdRaf !== null) { cancelAnimationFrame(holdRaf); holdRaf = null; holding = false; }
  }
  function unpinFinalStates() {
    if (reward && !respectDone) {
      stars.forEach(function (s) { s.classList.remove('lit'); });
      reward.classList.remove('show');
      holdP = 0;
    }
  }
  var reduceHandler = function (e) {
    setAnimClass();
    if (e.matches) pinToFinalStates();
    else { unpinFinalStates(); applyHeroMode(); }
  };
  if (reduceMq.addEventListener) reduceMq.addEventListener('change', reduceHandler); else reduceMq.addListener(reduceHandler);
  if (reduceMq.matches) pinToFinalStates();

  /* ---------- Shopify Theme-Editor: Sektionen live neu laden ---------- */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { location.reload(); });
  }

  /* ---------- Test-Parameter (nur fuer die Qualitaetspruefung) ---------- */
  try {
    var qp = new URLSearchParams(location.search);
    if (qp.has('t-seek') || qp.has('t-y') || qp.has('t-reveal') || qp.has('t-cut')) {
      document.documentElement.style.scrollBehavior = 'auto';
      killBoot(true);
      if (qp.has('t-cut') && hero) hero.style.display = 'none';
      if (qp.has('t-seek')) window.__vyce.seek(parseFloat(qp.get('t-seek')) || 0);
      if (qp.has('t-y')) scrollTo(0, parseFloat(qp.get('t-y')) || 0);
      if (qp.has('t-reveal')) {
        var ts = document.createElement('style');
        ts.textContent = '.bp [pathLength],.divider .road{transition:none!important;stroke-dashoffset:0!important}.rev,.card,.look-row{transition:none!important}';
        document.head.appendChild(ts);
        window.__vyce.revealAll();
      }
    }
  } catch (e) {}
})();
